import {SlicePipe} from '@angular/common';
import {Component, computed, effect, inject, input} from '@angular/core';
import {IonRow} from '@ionic/angular/standalone';
import {TranslocoDirective} from '@jsverse/transloco';
import {environment} from '../../../environments/environment';
import {AppAvatarComponent, AvatarStatus} from '@components';
import {Profile} from '@models';
import {PresenceService, ProfileService} from '@services';

@Component({
	           selector: 'app-mini-user-card',
	           standalone: true,
	           imports: [
			TranslocoDirective,
		           IonRow,
		           AppAvatarComponent,
		           SlicePipe
	           ],
	           templateUrl: './mini-user-card.component.html',
	           styleUrls: ['mini-user-card.component.scss']
           })
export class MiniUserCardComponent {
	selectedProfile = input.required<Profile>();
	profile = input<Profile>();

	public selected_status: AvatarStatus = 'offline';
	protected readonly environment = environment;
	protected profileService: ProfileService;
	private presenceService: PresenceService;

	// Calculate compatibility score between current profile and selected profile
	protected compatibilityScore = computed(() => {
		const current = this.profileService.profile();
		const selected = this.selectedProfile();
		if (!current || !selected || current.uuid === selected.uuid) {
			return null;
		}
		return current.calculateCompatibilityScore(selected);
	});

	constructor() {
		this.profileService = inject(ProfileService);
		this.presenceService = inject(PresenceService);
		effect(() => {
			const selected = this.selectedProfile();
			const currentProfile = this.profileService.profile();
			if (!selected || !currentProfile) {
				return;
			}
			selected.isBlocked = currentProfile.blocked?.find(uid => uid === selected.uuid) !== undefined;
			selected.isFavorite = currentProfile.favorits?.find(uid => uid === selected.uuid) !== undefined;
			const snapshot = this.presenceService.getPresence(selected.uuid)();
			if (snapshot) {
				const status = snapshot.status;
				this.selected_status = this.isAvatarStatus(status) ? status : 'offline';
			}
		});
	}

	private isAvatarStatus(value: string): value is AvatarStatus {
		return value === 'online' || value === 'offline' || value === 'away' || value === 'busy';
	}

	protected getInitials(username: string): string {
		if (!username || !username.trim()) {
			return '?';
		}
		const parts = username.trim().split(/\s+/);
		if (parts.length >= 2) {
			return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
		}
		return username.slice(0, 2).toUpperCase();
	}
}
